export const services_data = [
	{
		title: 'Transparent & Open',
		desc: "Once You've Set Up Your Wallet Of Choice, Connect It To Bit5 Clicking The Connect Wallet In The Top Right Corner.",
		id: '0NFT Consultant Analytics',
		icon: 'service-ico-1',
	},
	{
		title: 'Fast Support',
		desc: "We Are Here To Help You. Our Support Team Is Available 24/7 To Answer Any Questions You May Have.",
		id: '1NFT Marketing',
		icon: 'service-ico-2',
	},
	{
		title: 'No Auto-Liquidations',
		desc: "We Do Not Use Auto-Liquidations. We Believe In The Power Of The Community To Help Each Other.",
		id: '2NFT Strategy',
		icon: 'service-ico-3',
	},
	{
		title: 'NFT Technology',
		desc: "We Are A Team Of Experienced Professionals With A Passion For Blockchain Technology And NFTs.",
		id: '3NFT Technology',
		icon: 'service-ico-4',
	},
	{
		title: 'Advisers & Intermediaries',
		desc: "Our Team Will Help You With All The Steps Of Your Nft, From The Creation To The Sale.",
		id: '4Advisers & Intermediaries',
		icon: 'service-ico-5',
	},
	{
		title: 'Secure & Double-Audited',
		desc: "All Core And Smart Contracts Are Open Source And Audited By Reputable Security Firms.",
		id: '5ICO Token',
		icon: 'service-ico-6',
	},
];
